<template>
    <navbar position="fixed"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto" class="navbar-expand-lg bg-primary">
        <template>
                <router-link class="navbar-brand" to="/">
                    <img
                        :src="image4"
                        alt="Burnley Sales & Lettings logo"
                    >
                </router-link>
                
        </template>
        <template slot="navbar-menu">
            <li class="nav-item">
                <a
                class="nav-link"
                href="/"
                >
                <p>Home</p>
                </a>
            </li>

            <!--li class="nav-item">
                <a
                class="nav-link"
                href="/blog"
                >
                <p>Blog</p>
                </a>
            </li-->

            <drop-down tag="li" title="Sales" class="nav-item">
                <nav-link class="dropdown-item" to="/sales">
                    Properties for sale
                </nav-link>
                <nav-link class="dropdown-item" to="/sellers">
                    Sellers
                </nav-link>
                <nav-link class="dropdown-item" to="/buyers">
                    Buyers
                </nav-link>
            </drop-down>
            <drop-down tag="li" title="Lettings" class="nav-item">
                <nav-link class="dropdown-item" to="/lettings">
                    Properties to let
                </nav-link>
                <nav-link class="dropdown-item" to="/landlords">
                    Landlords
                </nav-link>
                <nav-link class="dropdown-item" to="/tenants">
                    Tenants
                </nav-link>
            </drop-down>

            <li class="nav-item">
                <a
                class="nav-link"
                href="/finance"
                >
                <p>Financial Services & Investments</p>
                </a>
            </li>

            <li class="nav-item">
                <a
                class="nav-link"
                href="/accreditations"
                >
                <p>Accreditations</p>
                </a>
            </li>

            <li class="nav-item">
                <a
                class="nav-link"
                href="/maintenance"
                >
                <p>Maintenance</p>
                </a>
            </li>

            <li class="nav-item">
                <a
                class="nav-link"
                href="/contact-us"
                >
                <p>Contact Us</p>
                </a>
            </li>
        </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: String,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    },
    data() {
        return {
            image4: require("../../public/img/logo.png"),
        }
    }
  }
</script>

<style scoped>

</style>
